/** @jsx h */
import { h } from 'preact'

import CheckingIcon from '../../../assets/images/svgs/icon-checking-v2.svg'
import EvidencedIcon from '../../../assets/images/svgs/icon-evidenced-v2.svg'
import VerifiedIcon from '../../../assets/images/svgs/icon-verified-v2.svg'
import t from '../../utils/translate'

/**
 * A component that displays a Proof Point status.
 * It's always 'checking' initially, then it becomes
 * either 'evidenced' or 'verified'. The state change
 * is done by ProofPointStatus Stimulus controller.
 */
const ProofPointStatus = ({ status, hideText, evidencedText, verifiedText }) =>
  <proof-point-status-wrapper
    data-controller='proof-point-status'
    data-proof-point-status-status-value={status}
    aria-label={`${status} claim`}
  >
    <proof-point-status checking aria-hidden='true'>
      <CheckingIcon />&nbsp;{hideText ? '' : t('js.checking') + '…'}
    </proof-point-status>

    <proof-point-status evidenced hidden aria-hidden='true'>
      <EvidencedIcon />&nbsp;{hideText ? '' : (evidencedText || t('js.evidenced'))}
    </proof-point-status>

    <proof-point-status verified hidden aria-hidden='true'>
      <VerifiedIcon />&nbsp;{hideText ? '' : (verifiedText || t('js.verified_label'))}
    </proof-point-status>
  </proof-point-status-wrapper>

export default ProofPointStatus
